/* unplugin-vue-components disabled */import script from "./RoateText.vue?vue&type=script&setup=true&lang=js"
export * from "./RoateText.vue?vue&type=script&setup=true&lang=js"

import "./RoateText.vue?vue&type=style&index=0&id=7d042ca9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d042ca9"]])

export default __exports__